import { getWwwWebFilterDestinationSuggestions } from '@/api/generated/www-web-filters/www-web-filters';
import type { ListRequest, WebFilterDestinationSuggestion } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';

export interface WebFilterDestinationRef {
  destinationId: number;
  name: string;
  code: string | null;
}

export const destinationSelector = defineEntityAsyncSelector<
  WebFilterDestinationRef,
  WebFilterDestinationSuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getWwwWebFilterDestinationSuggestions,
    buildApiParams: (ctx) => toListRequest(ctx.search, ctx.ids, ctx.extraFilters ?? []),
    queryKey: (request) => listRequestQueryKey('www.web-filters.destinations', request),
    mapItem: (s) => ({
      destinationId: s.destinationId,
      name: s.name,
      code: s.code ?? null,
    }),
  },
  key: (item) => item.destinationId,
  objectCategory: 'Destination',
  listPicker: 'legacy',
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
    code: (item) => item.code,
  },
  columns: (t) =>
    selectorPresets.nameAndCode({
      name: {
        id: 'nazev',
        header: t('webFilter.criteria.selectors.columns.name'),
        value: (item) => item.name,
        sortable: true,
      },
      code: {
        id: 'zkratka',
        header: t('webFilter.criteria.selectors.columns.code'),
        value: (item) => item.code,
        emptyDash: '—',
      },
    }),
  i18n: { namespace: 'www' },
});
